import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from 'react';
import {DEFAULT_RELATION, FIELD_STATUS, FILE_IMAGE, PB_FILED_TYPE, RELATION_TYPE} from "../../../../common/constant";
import Select from "react-select";
import {useSelector} from "react-redux";
import {getKeyName, getLabelValue} from 'ubs-framework/v2/common/function'
import UCheckBox from "ubs-framework/v2/UCheckBox";
import UTooltip from "ubs-framework/v2/Utooltip";
import AddNewButton from "ubs-framework/v2/common/UFilters/AddNewBtn/AddNewBtn";
import UInput from "ubs-framework/v2/UInput";
import UDatePicker from "ubs-framework/v2/UDatePicker";
import {clearValidation, Encryption, isThisAFile, showToastSuccess, timeStampUnix} from "ubs-framework/v2/common/function";
import {getCookie} from "ubs-framework/v2/common/function";
import useSocket from "../../../common/hooks/useSocket";
import * as Icon from 'ubs-icons';
import {COLOR, CONSTANT, PROFILE_SECTION} from "ubs-framework/v2/common/constant";
import UCountryMobile from "ubs-framework/v2/UCountryMobile"
import {api, sendData} from "../../../../store/actions";
import UNoDataFound from 'ubs-framework/v2/UErrorPages/UNoDataFound';
import UAlertMessage from 'ubs-framework/v2/UAlertMessage';
import useUAlert from "ubs-framework/v2/UAlert";
import UToggleSwitch from "ubs-framework/v2/UToggleSwitch";
import UPopup from "ubs-framework/v2/UPopup";
import {FileAttachment, AddFile} from "../../../common/file-attachment";
import FileProgressBar from "../../../../common/components/progressbar";
import { useFieldLabel } from "ubs-framework/v2/hooks/useCustomFieldConfig";

const FamilyInformation = forwardRef((props, ref) => {
    const alert = useUAlert();
    const getLabel = useFieldLabel();
    const randomIdRef = useRef({});

    const _FS_LV = useSelector(e => getLabelValue(e.hrms.familyInfo));
    const _ORG_ID = useSelector(e => e.common.orgId);
    const _SOCKET_ID = useSelector(e => e.common.socketId);
    const _FSL = useSelector(e => e?.common?.settings?.maxFileSizeLimit);

    const fatherRoleId = _FS_LV?.find( _ => _?.name?.trim() === DEFAULT_RELATION.father)?.value || null;
    const motherRoleId = _FS_LV?.find( _ => _?.name?.trim() === DEFAULT_RELATION.mother)?.value || null;
    const spouseRoleId = _FS_LV?.find( _ => _?.name?.trim() === DEFAULT_RELATION.spouse)?.value || null;
    const childrenRoleId = _FS_LV?.find( _ => _?.name?.trim() === DEFAULT_RELATION.children)?.value || null;
    const parentIds = [fatherRoleId, motherRoleId];
    const spouseIds = [spouseRoleId];
    const childrenIds = [childrenRoleId];
    const otherIds = _FS_LV?.filter( _ => !([fatherRoleId, motherRoleId, spouseRoleId, childrenRoleId]?.includes(_?.value)) ? _?.value : null )?.map( _ => _.value );

    const [dataLoading, setDataLoading] = useState(false);
    const [familyInfoSettings, setFamilyInfoSettings] = useState({});
    const [familyInfo, setFamilyInfo] = useState([]);
    const [showFamilyInfo, setShowFamilyInfo] = useState(false);
    const [res, setRes] = useState({});
    const [loading, setLoading] = useState(false);

    const {on, refresh , off} = useSocket(res => {
        if (!res.error) {
            switch (res.event) {
                case 'ats|pre|boarding|proofDocument|fetch':
                    const isFamilyInfo = res?.data?.result?.defaultField?.some( _ => _?.type === PB_FILED_TYPE.ARR_OF_OBJ && _?.value === 'familyInfo' && _?.status !== FIELD_STATUS.OFF );
                    if(isFamilyInfo){
                        setShowFamilyInfo(isFamilyInfo || false)
                        handle?.prepareFamilyInfo(res);
                        setRes(res)
                    }
                    break;
                case 'common|file|remove': {
                    showToastSuccess('File Removed Successfully');
                    setFamilyInfo(prevFamilyInfo => {
                        let updatedList = JSON.parse(JSON.stringify(prevFamilyInfo)) || [];
                        const removedIds = res?.data?.removedFiles || res?.data?.removeFiles || res?.data?._id;
                        const removedIdArray = Array.isArray(removedIds) ? removedIds : (removedIds ? [removedIds] : []);
                        if (removedIdArray.length === 0) return updatedList;
                        updatedList.forEach(sec => {
                            if (sec?.list) {
                                sec?.list?.forEach(member => {
                                    if (member?.attachments) {
                                        member.attachments = member.attachments.filter(e => !removedIdArray.includes(e?._id));
                                    }
                                });
                            }
                        });
                        return updatedList;
                    });
                    break;
                }
                default : break;
            }
        }
    });

    useEffect(() =>{
        on();
        return () => off();
    },[_FS_LV, props?.maritalStatus, props?.showFamilyInfo])

    useEffect(() =>{
     if(res.data?.result && !props?.viewOnly) handle?.prepareFamilyInfo(res);
    },[props?.maritalStatus, props?.showFamilyInfo, props?.viewOnly])
    useImperativeHandle(ref, ()=> {
        return {
            getFamilyInfo : () => {
                let familyValue = {
                    familyInfo : [],
                    isChildrenCovered : false,
                }
                familyInfo?.forEach((sec, secIndex) => {
                    sec?.list?.forEach(e => {
                        let data = {
                            familyRole: e?.familyRole,
                            name: e?.name?.trim(),
                            dob: e?.dob ? timeStampUnix(e?.dob) : null,
                            occupation: e?.occupation,
                            gender: e?.gender ? e?.gender : null,
                            aadharNumber: e?.aadharNumber,
                            mobileNumber: e?.mobileNumber,
                            mobileNumberCC: e?.mobileNumberCC,
                            isHandicapped: e?.isHandicapped,
                            handicappedPercentage: e?.handicappedPercentage,
                            files: e?.attachments?.map(_ => ({
                                _id: _?._id,
                                url: _?.url || "",
                            })).filter(_ => _?._id) || [],
                        }
                        if(parentIds?.includes(e?.familyRole)){
                            data.type = e?.type ? e?.type : (e?.familyRole === fatherRoleId ? RELATION_TYPE.FATHER : e?.familyRole === motherRoleId ? RELATION_TYPE.MOTHER : null);
                            data.isLate = !!e?.isLate
                            if(data.isLate) data.dateOfDeath = e?.dateOfDeath ? timeStampUnix(e?.dateOfDeath) : null
                        }else if(spouseIds?.includes(e?.familyRole)){
                            data.type = e?.type ? e?.type : RELATION_TYPE.SPOUSE;
                            data.isLate = Boolean(e?.isLate)
                            if(data.isLate) data.dateOfDeath = e?.dateOfDeath ? timeStampUnix(e?.dateOfDeath) : null
                            data.dateOfDivorce = e?.dateOfDivorce ? timeStampUnix(e?.dateOfDivorce) : null
                            data.weddingAnniversaryDate = e.weddingAnniversaryDate ? timeStampUnix(e.weddingAnniversaryDate) : null
                        }else if(childrenIds?.includes(e?.familyRole)){
                            data.type = e?.type ? e?.type : RELATION_TYPE.CHILDREN;
                            delete data?.occupation
                            delete data?.mobileNumber
                            delete data?.mobileNumberCC
                            data.isEligibleForInsurance = !!e?.isEligibleForInsurance
                            data.maritalStatus = e?.maritalStatus || null;
                            /** For Female only we are showing married date */
                            data.weddingAnniversaryDate = e.weddingAnniversaryDate ? timeStampUnix(e.weddingAnniversaryDate) : null
                            data.dateOfDivorce = e.dateOfDivorce ? timeStampUnix(e.dateOfDivorce) : null
                        }
                        if(data?.name && data?.familyRole) familyValue?.familyInfo?.push(data)
                    });

                    if(secIndex === 2){
                        /** children */
                        familyValue.isChildrenCovered = Boolean(sec?.isChildrenCovered)
                    }
                });
                if (familyValue?.familyInfo?.length === 0) familyValue.isChildrenCovered = false;
                return familyValue;
            }
        }
    }, [familyInfo, parentIds, spouseIds, childrenIds, RELATION_TYPE])


    const handle = {
        prepareFamilyInfo: (res) => {
            res.data.result.familyInfo = res.data?.result?.familyInfo ? res.data?.result?.familyInfo : []
            let isMarried = props?.maritalStatus === 'married' || res?.data?.result?.fields?.maritalStatus === 'married';
            let isDivorce = props?.maritalStatus === 'divorced' || res?.data?.maritalStatus === "divorced" || null
            let isWidowed = props?.maritalStatus === 'widowed' || res?.data?.maritalStatus === "widowed"  || null

            let isRequired  = res?.data.result?.defaultField?.find( _=> _?.value === "familyInfo")?.status === 1
            let family = JSON.parse(JSON.stringify(res.data?.result?.familyInfo));
            const familyInfoSettings = res?.data?.result?.familyInfoSettings || {}

            let isChildrenCovered = res?.data?.result?.isChildrenCovered

            let familyInfoGroup = [
                {show: false, section: "Parents Detail", list: [], showRole: true},
                {show: false, section: "Spouse Detail", list: [], showRole: true},
                {show: false, section: "Children Detail", list: [], showRole: true,  isChildrenCovered: false},
                {show: true, section: "Other Members Detail", list: [], showRole: true},
            ];
            let parents = family?.filter(_ => parentIds?.includes(_?.familyRole));
            let spouse = family?.filter(_ => spouseIds.includes(_?.familyRole));
            let children = family?.filter(_ => childrenIds.includes(_?.familyRole));
            let other = family?.filter(_ => otherIds.includes(_?.familyRole));

            /** parents*/
            if (parents?.length > 0) {
                parents = parents?.map(e => {
                    e.type = (fatherRoleId ===  e.familyRole) ? RELATION_TYPE.FATHER : (motherRoleId ===  e.familyRole) ? RELATION_TYPE.MOTHER : null
                    e = {...e}
                    e.isLate = Boolean(e?.isLate);
                    e.familyRole = e.familyRole
                    e.name = e?.name ? e?.name : ''
                    e.dob = e?.dob ? new Date(e?.dob) : ''
                    e.dateOfDeath = e?.dateOfDeath ? new Date(e?.dateOfDeath) : ''
                    e.dateOfDivorce = e?.dateOfDivorce ? new Date(e?.dateOfDivorce) : ''
                    e.isHandicapped = Boolean(e?.isHandicapped)
                    e.handicappedPercentage = e?.handicappedPercentage ? e?.handicappedPercentage : ""
                    e.occupation = e?.occupation ? e?.occupation : ''
                    e.gender = e?.gender ? e?.gender : null;
                    e.mobileNumber = e.mobileNumber || null;
                    e.mobileNumberCC = e.phoneNumberCC || e.mobileNumberCC || null;
                    e.aadharNumber = e.aadharNumber ? e.aadharNumber : ""
                    e.isRequired = props?.isRecruiterSide ? false :  (isRequired || familyInfoSettings?.isParentsInfoEnabled || false)
                    if (e?.files?.length) {
                        e.attachments = e?.files || [];
                    }
                    return e
                });
                if(parents?.length <= 1){
                    let availableRelation = parents?.find( _ => parentIds?.includes(_?.familyRole));
                    /** check if father Data available but mOther data not available vise versa  */
                    if(availableRelation?.familyRole === fatherRoleId){
                        let e = {
                            hideFamilyRole: true,
                            type: RELATION_TYPE.MOTHER,
                            familyRole: motherRoleId,
                            isLate: false,
                            name: "",
                            dob: null,
                            dateOfDeath: null,
                            dateOfDivorce: null,
                            isHandicapped: false,
                            handicappedPercentage: "",
                            occupation: "",
                            gender: "female",
                            mobileNumber: "",
                            mobileNumberCC: "",
                            aadharNumber: "",
                            attachments: [],
                            isRequired : props?.isRecruiterSide ? false : isRequired || familyInfoSettings?.isParentsInfoEnabled || false
                        }
                        parents?.push(e)
                    }else if(availableRelation?.familyRole === motherRoleId){
                        let e = {
                            hideFamilyRole: true,
                            type: RELATION_TYPE.FATHER,
                            familyRole: fatherRoleId,
                            isLate: false,
                            name: "",
                            dob: null,
                            dateOfDeath: null,
                            dateOfDivorce: null,
                            isHandicapped: false,
                            isHandicappedPercentage: "",
                            occupation: "",
                            gender: "female",
                            mobileNumber: "",
                            mobileNumberCC: "",
                            aadharNumber: "",
                            attachments: [],
                            isRequired : props?.isRecruiterSide ? false : isRequired || familyInfoSettings?.isParentsInfoEnabled || false
                        }
                        parents?.push(e)
                    }

                }
                familyInfoGroup[0] = {
                    ...familyInfoGroup[0],
                    list: parents,
                    show: true,
                    showRole: false
                }

            } else {
                familyInfoGroup[0] = {
                    ...familyInfoGroup[0],
                    list: [
                        {
                            hideFamilyRole: true,
                            type: RELATION_TYPE.FATHER,
                            familyRole: fatherRoleId,
                            isLate: false,
                            name: "",
                            dob: null,
                            dateOfDeath: null,
                            dateOfDivorce: null,
                            isHandicapped: false,
                            handicappedPercentage: "",
                            occupation: null,
                            gender: "male",
                            mobileNumber: null,
                            mobileNumberCC: null,
                            aadharNumber: null,
                            attachments: [],
                            isRequired : props?.isRecruiterSide ? false : isRequired || familyInfoSettings?.isParentsInfoEnabled || false

                        },
                        {
                            hideFamilyRole: true,
                            type: RELATION_TYPE.MOTHER,
                            familyRole: motherRoleId,
                            isLate: false,
                            name: "",
                            dob: null,
                            dateOfDeath: null,
                            dateOfDivorce: null,
                            isHandicapped: false,
                            handicappedPercentage: "",
                            occupation: "",
                            gender: "female",
                            mobileNumber: "",
                            mobileNumberCC: "",
                            aadharNumber: "",
                            attachments: [],
                            isRequired : props?.isRecruiterSide ? false : isRequired || familyInfoSettings?.isParentsInfoEnabled || false
                        },
                    ],
                    show: true,
                    showRole: false
                }
            }

            /** spouse */
            if (isMarried || isDivorce || isWidowed) {
                if (spouse?.length > 0) {
                    spouse = spouse?.map(e => {
                        e = {...e}
                        if (!e?.type) e.type = RELATION_TYPE.SPOUSE
                        e.isLate = Boolean(e?.isLate);
                        e.familyRole = e.familyRole;
                        e.name = e?.name ? e?.name : ''
                        e.dob = e?.dob ? new Date(e?.dob) : ''
                        e.dateOfDeath = e?.dateOfDeath ? new Date(e?.dateOfDeath) : ''
                        e.dateOfDivorce = e?.dateOfDivorce ? new Date(e?.dateOfDivorce) : ''
                        e.isHandicapped = Boolean(e?.isHandicapped);
                        e.handicappedPercentage = e?.handicappedPercentage ? e?.handicappedPercentage : "";
                        e.occupation = e?.occupation ? e?.occupation : ''
                        e.gender = e?.gender ? e?.gender : null;
                        e.mobileNumber = e.mobileNumber || null;
                        e.mobileNumberCC = e.phoneNumberCC || e.mobileNumberCC || null;
                        e.aadharNumber = e.aadharNumber ? e.aadharNumber : ""
                        e.attachments = (e?.files || e?.attachments || []).map(file => ({
                            ...file,
                            randomId: file?.randomId || ''
                        }))
                        e.weddingAnniversaryDate = e.weddingAnniversaryDate ? new Date(e.weddingAnniversaryDate) : null;
                        e.isRequired = props?.isRecruiterSide ? false : isRequired || (familyInfoSettings?.isFamilyInfoEnabled) || false;
                        return e
                    });
                    familyInfoGroup[1] = {
                        ...familyInfoGroup[1],
                        list: spouse,
                        show: true,
                        showRole: false
                    }
                } else {
                    let e = {
                        hideFamilyRole: true,
                        type: RELATION_TYPE.SPOUSE,
                        familyRole: spouseRoleId,
                        isLate: false,
                        name: "",
                        dob: null,
                        dateOfDeath: null,
                        dateOfDivorce: null,
                        isHandicapped: false,
                        handicappedPercentage: "",
                        occupation: null,
                        gender: "",
                        mobileNumber: null,
                        mobileNumberCC: null,
                        aadharNumber: null,
                        attachments: [],
                        isRequired: props?.isRecruiterSide ? false : isRequired || (familyInfoSettings?.isFamilyInfoEnabled) || false,
                        weddingAnniversaryDate: null,
                    };
                    familyInfoGroup[1] = {
                        ...familyInfoGroup[1],
                        list: [e],
                        show: true,
                        showRole: false
                    }

                }
            }

            /** children */
            if (isMarried || isDivorce || isWidowed) {
                if (children?.length > 0) {
                    children = children?.map(e => {
                        e = {...e}
                        e.type = RELATION_TYPE.CHILDREN
                        e.familyRole = childrenRoleId;
                        e.name = e?.name ? e?.name : ''
                        e.dob = e?.dob ? new Date(e?.dob) : ''
                        e.gender = e?.gender ? e?.gender : null;
                        e.aadharNumber = e.aadharNumber ? e.aadharNumber : ""
                        e.attachments = (e?.files || e?.attachments || []).map(file => ({
                            ...file,
                            randomId: file?.randomId || ''
                        }))
                        return e
                    });
                    familyInfoGroup[2] = {
                        ...familyInfoGroup[2],
                        list: children,
                        show: true,
                        showRole: false,
                        isChildrenCovered: isChildrenCovered || false
                    }
                } else {
                    familyInfoGroup[2] = {
                        ...familyInfoGroup[2],
                        list: [],
                        show: true,
                        showRole: false,
                        isChildrenCovered: false
                    }
                }
            }

            /** Other */
            if (other?.length > 0) {
                other = other?.map(e => {
                    e = {...e}
                    e.hideFamilyRole = false;
                    e.familyRole = e.familyRole;
                    e.name = e?.name ? e?.name : ''
                    e.dob = e?.dob ? new Date(e?.dob) : ''
                    e.occupation = e?.occupation ? e?.occupation : ''
                    e.gender = e?.gender ? e?.gender : null;
                    e.mobileNumber = e.mobileNumber || null;
                    e.mobileNumberCC = e.phoneNumberCC || e.mobileNumberCC || null;
                    e.aadharNumber = e.aadharNumber ? e.aadharNumber : ""
                    e.attachments = (e?.files || e?.attachments || []).map(file => ({
                        ...file,
                        randomId: file?.randomId || ''
                    }))
                    e.type = RELATION_TYPE.OTHER
                    return e
                });
                familyInfoGroup[3] = {
                    ...familyInfoGroup[3],
                    list: familyInfoGroup[3].list?.concat(other),
                }
            }

            const maritalStatus =  CONSTANT.MARITAL_STATUS_LIST?.find( _=> _?.value === props?.maritalStatus) || ''
            setFamilyInfoSettings({...(res?.data?.result?.familyInfoSettings && res?.data?.result?.familyInfoSettings), isMarried, isRequired, isDivorce, isWidowed, maritalStatus})
            setFamilyInfo(familyInfoGroup);
        },
        changeFamily: (e, name, index,secIndex) => {
            let list = JSON.parse(JSON.stringify(familyInfo)) || [];

            if(name === 'isChildrenCovered' && index === null){
                list[secIndex].isChildrenCovered = e;
                if(!e){
                    (list[secIndex].list) ? list[secIndex].list = [] : null;
                    clearValidation(props?.validator, [], true)
                }else if (list[secIndex]?.list?.length === 0) {
                    let isEligibleForInsurance = handle?.checkForInsurance()
                    if (Array?.isArray(list[secIndex].list)) {
                        const data = {
                            familyRole: childrenRoleId || null,
                            name: "",
                            dob: null,
                            gender: null,
                            aadharNumber: "",
                            isEligibleForInsurance,
                            isChildren: true,
                            isRequired:  props?.isRecruiterSide ? false : true
                        }
                        list[secIndex].list = [...list[secIndex].list, data]
                    }
                }
            }else if ( name === "isEligibleForInsurance"){
                let isEligibleForInsurance = handle?.checkForInsurance()
                if(!isEligibleForInsurance && e){
                    alert.show({
                        title: `Warning`,
                        description: `Maximum ${familyInfoSettings?.maxChildrenCount} children are eligible for ${getLabel(PROFILE_SECTION.basicInfo, 'companyId', 'Company')} insurance`,
                        icon: <Icon.Warning fill={COLOR.u_red} size={30}/>
                    })
                    return
                }
                if (list[secIndex].list[index]) list[secIndex].list[index][name] = e;

            }else if(name === 'familyRole'){
                if (list[secIndex].list[index]){
                    if (e) {
                        list[secIndex].list[index][name] = e;
                    } else if(!e) {
                        clearValidation(props?.validator, [], true);
                        list[secIndex].list[index][name] = e;
                    }
                }
            }else if(name === 'isHandicapped'){
                if(!e) props?.validator?.current?.purgeFields();
                if (list[secIndex].list[index]) list[secIndex].list[index][name] = e;
            }else {
                if (list[secIndex].list[index]) list[secIndex].list[index][name] = e;
            }

            if(name === 'isLate' && e){
                /** onSelect late hide other fileds*/
                clearValidation(props?.validator, [], true);
            }

            if(name === 'isDivorce' && e){
                /** onSelect dateOfDivorce hide other fileds*/
                clearValidation(props?.validator, [], true);
            }

            if (name === 'country' || name === 'province') {
                if (list[secIndex].list[index]) list[secIndex].list[index][name] = e?.value
                if (name === 'country') {
                    setCurrentCountry(e?.value);
                    if (list[secIndex].list[index]) list[secIndex].list[index]['province'] = ''
                    sendData('addressParams', {country: e?.value})
                }
                setFamilyInfo(list);
            } else {
                setFamilyInfo(list);
            }
            props?.validator?.current?.purgeFields();
            props?.setIsFamilyChange(false)
        },
        mobileNumber: (e, name, index, secIndex) => {
            let list = JSON.parse(JSON.stringify(familyInfo)) || [];
            if (list[secIndex].list[index]) {
                list[secIndex].list[index].mobileNumber = e.phone
                list[secIndex].list[index].mobileNumberCC = e.code
            }
            setFamilyInfo(list);
            props?.setIsFamilyChange(false)
        },
        addMoreFamily: (secIndex) => {
            let list = JSON.parse(JSON.stringify(familyInfo)) || [];
            if (list[secIndex].list) {
                const data = {
                    familyRole: null,
                    name: "",
                    occupation: "",
                    dob: null,
                    gender: null,
                    aadharNumber: "",
                    attachments: [],
                }
                list[secIndex].list?.push(data);
            }
            setFamilyInfo(list);
            props?.setIsFamilyChange(false)
        },
        deleteMoreFamily: (index, secIndex) => {
            clearValidation(props?.validator, [], true)
            let list = JSON.parse(JSON.stringify(familyInfo)) || [];
            if (list[secIndex].list) {
                list[secIndex].list = list[secIndex].list?.filter((_, j) => j !== index)
            }
            setFamilyInfo(list);
            props?.setIsFamilyChange(false)
        },
        addMoreChildren: (secIndex) => {
            let isEligibleForInsurance = handle?.checkForInsurance()
            let list = JSON.parse(JSON.stringify(familyInfo)) || [];
            if (Array?.isArray(list[secIndex].list)) {
                const data = {
                    familyRole: childrenRoleId || null,
                    name: "",
                    dob: null,
                    gender: null,
                    aadharNumber: "",
                    attachments: [],
                    isEligibleForInsurance,
                    isChildren: true,
                    isRequired:  props?.isRecruiterSide ? false : true,
                    weddingAnniversaryDate: null,
                    maritalStatus: null,
                    dateOfDivorce: null,
                }
                list[secIndex].list = [...list[secIndex].list, data]
            }
            setFamilyInfo(list);
            props?.setIsFamilyChange(false);
        },
        checkForInsurance : () => {
            if(familyInfoSettings?.isChildrenInfoEnabled && familyInfoSettings?.isFamilyInfoEnabled && (familyInfoSettings?.isMarried  || familyInfoSettings?.isDivorce || familyInfoSettings?.isWidowed)){
                return Boolean(familyInfo[2]?.list?.filter(_ => _?.isEligibleForInsurance)?.length < Number(familyInfoSettings?.maxChildrenCount))
            }else return false;
        },
        deleteMoreChildren: (index, secIndex) => {
            clearValidation(props?.validator, [], true);
            let list = JSON.parse(JSON.stringify(familyInfo)) || [];
            if (Array?.isArray(list[secIndex].list)) {
                list[secIndex].list?.splice(index, 1);
                if(list[secIndex].list?.length === 0){
                    list[secIndex].isChildrenCovered = false;
                }
            }
            setFamilyInfo(list);
            props?.setIsFamilyChange(false)
        },
        file: async (e, index, secIndex) => {
            e?.stopPropagation();
            let list = JSON.parse(JSON.stringify(familyInfo)) || [];
            let member = list[secIndex]?.list[index];
            if (!member) return;

            const fieldValuesLocalState = { attachments: member?.attachments || [] };

            const file = e?.target?.files;
            let myFiles = [];

            let sizeError = false;
            const fileArray = Object.assign([], file);

            let fileLength = fileArray?.length + fieldValuesLocalState?.attachments?.length;
            if (fileLength <= 3 && fileLength !== 0) {
                setLoading(`${secIndex}_${index}`);

                for (let i = 0; i < fileArray.length; i++) {
                    if (!sizeError) sizeError = fileArray[i].size / 1024 / 1024 > _FSL;
                }
                if (!sizeError) {
                    const number = file?.length;
                    for (let i = 0; i < number; i++) {
                        const name = fileArray[i].name.split('.');
                        const ext = name[name.length - 1];
                        if (FILE_IMAGE.MIXFILES.exec(fileArray[i].name)) {
                            if (!FILE_IMAGE.EXCLUDES.includes(ext)) {
                                await isThisAFile(fileArray[i]).then(validFile => {
                                    myFiles.push(validFile);
                                }).catch(error => {
                                });
                            }
                        } else {
                            alert.show({ title: 'Something went wrong.', description: 'Unsupported File.' });
                            setLoading(false);
                            if (document.getElementById('upload')) document.getElementById('upload').value = '';
                            return;
                        }
                    }

                    if (!randomIdRef.current[`${secIndex}_${index}`]) {
                        randomIdRef.current[`${secIndex}_${index}`] = Math.random().toString(36).substr(2, 6).toString();
                    }

                    let params = {
                        attachments: myFiles?.map(_ => _?._id).filter(e => e) || [],
                        randomId: randomIdRef.current[`${secIndex}_${index}`]
                    };

                    var payload = {}, fileList = {};

                    for (let i = 0; i < myFiles?.length; i++) {
                        const rId = Math.random().toString(36).substr(2, 9).toString();
                        let file = myFiles[i]
                        const lastModified = file.lastModified || new Date().getTime();

                        const stableFile = new File([file], file.name, {
                            type: file.type,
                            lastModified: lastModified
                        });
                        payload[rId] = {
                            size: file.size,
                            fileName: file.name,
                            mimeType: file.type,
                            lastModified: lastModified,
                        };
                        fileList[rId] = stableFile;
                    }

                    const body = {
                        event: 'common|file|upload',
                        socketId: _SOCKET_ID,
                        data: { ...params, payload: payload, orgId: _ORG_ID, module: "RECRUIT", featureName: "familyInfo" , isRecruit: true }
                    }

                    const formData = new FormData();
                    formData.append('body', Encryption(body));

                    for (var key in fileList) {
                        formData.append(key, fileList[key]);
                    }

                    const config = { headers: { 'Authorization': `Bearer ${getCookie('ubs_token')}` }, };

                    api.post('/fileUpload', formData, config).then(res => {
                        if (res?.status === 200) {
                            let updatedList = JSON.parse(JSON.stringify(familyInfo)) || [];
                            let updatedMember = updatedList[secIndex]?.list[index];
                            if (updatedMember) {
                                let newFiles = res?.data?.files || res?.data?.attachments || [];
                                if (newFiles && !Array.isArray(newFiles)) newFiles = [newFiles];
                                const currentRandomId = randomIdRef.current[`${secIndex}_${index}`];
                                newFiles = newFiles.map(f => ({ ...f, randomId: currentRandomId }));
                                updatedMember.attachments = [...(updatedMember.attachments || []), ...newFiles]?.filter((item, index, self) => index === self?.findIndex(obj => obj._id === item._id));
                                setFamilyInfo(updatedList);
                                props?.setIsFamilyChange(false);
                            }
                            setLoading(false);
                        }
                    }).catch(error => {
                        alert.show({ title: 'Something went wrong.', description: error?.err, icon: <Icon.Warning fill={COLOR.u_red} /> });
                        setLoading(false);
                    });

                } else {
                    alert.show({ title: 'Something went wrong.', description: `Files must be smaller than ${_FSL}MB!` });
                    setLoading(false);
                }
            } else {
                alert.show({ title: 'Something went wrong.', description: `You can only upload 3 files at a time` });
                setLoading(false);
            }
        },
        deleteAttachment: (doc, file, fileIndex, index, secIndex) => {
            if (file?.randomId) {
                let params = {
                    module: "RECRUIT",
                    featureName: "familyInfo",
                    isRecruit: true,
                    randomId: file?.randomId,
                    removeFiles: file?._id,
                };
                sendData('common|file|remove', params);
            }
            setFamilyInfo(prev => {
                let data = JSON.parse(JSON.stringify(prev)) || [];
                if (data[secIndex]?.list?.[index]?.attachments) {
                    data[secIndex].list[index].attachments = data[secIndex].list[index].attachments.filter((_, i) => i !== fileIndex);
                }
                return data;
            });
            props?.setIsFamilyChange(false);
        },
    }

    if(showFamilyInfo){
        return (
            <React.Fragment>
                {
                    familyInfo?.map((section, secIndex) => {
                        if(!section?.show) return "";
                        return (
                            <React.Fragment key={section?.section}>
                                <div className="u_content-subheader small">
                                    <h5> {section?.section} </h5>
                                </div>

                                <div className="u_content-form u_p-20">

                                    { secIndex === 2 &&
                                        <div className="u_flex-align u_mb-16">
                                            <UCheckBox
                                                disableClass={props?.disabled}
                                                id={`isChildrenCovered${secIndex}`}
                                                name={`isChildrenCovered${secIndex}`}
                                                label="Do you have children ?"
                                                checked={section?.isChildrenCovered}
                                                onChange={(e) => handle.changeFamily(e?.target?.checked, 'isChildrenCovered', null, secIndex)}
                                            />
                                        </div>}

                                    {
                                        section?.list?.map((family, index) => {
                                            if(secIndex === 2 && !section?.isChildrenCovered) return "";

                                            return <div className={`u_row `} key={`section${index}${secIndex}`}>

                                                {/** Show is late to father and mother */}
                                                {[RELATION_TYPE.FATHER, RELATION_TYPE.MOTHER, RELATION_TYPE.SPOUSE]?.includes(family?.type) &&
                                                    <div className="u_col-12 u_mb-20  u_flex-align">
                                                        {family?.type === RELATION_TYPE.FATHER ? <h6>Father Detail</h6> : family?.type === RELATION_TYPE.MOTHER ? <h6>Mother Detail</h6> : family?.type === RELATION_TYPE.SPOUSE ? <h6>Husband / Wife Detail</h6> :  ""}
                                                        <UCheckBox
                                                            disableClass={props?.disabled}
                                                            className={`u_ml-15 ${(secIndex === 1 && !familyInfoSettings.isWidowed) ? 'u_disabled' : ''}`} // For Spouse info section is late is enable or didable based in marital status, if widow alloe to changess
                                                            id={`parentsInfo_isLate_${index}${secIndex}`}
                                                            name={`parentsInfo_isLate_${index}${secIndex}`}
                                                            label="Late"
                                                            checked={family?.isLate}
                                                            onChange={(e) => handle.changeFamily(e?.target?.checked, 'isLate', index, secIndex)}
                                                        />
                                                        <UTooltip
                                                            text={`Tick this box if the person has passed away. ${secIndex === 1 &&  'To use this option, select "Marital Status" to "Widowed" in the Basic Information.'}`}
                                                            on={open => (
                                                                <div className="u_ml-10 u_mr-15" onClick={() => {}}><Icon.InfoTooltip fill={COLOR.u_icon_bg} size={18}/></div>
                                                            )}
                                                        />

                                                        {/***  Visible tto Spouse detail section only */}
                                                        {(secIndex === 1 && familyInfoSettings?.maritalStatus?.label) &&
                                                        <UAlertMessage success>
                                                            <p className="u_flex-align"> {getLabel(PROFILE_SECTION.basicInfo, 'maritalStatus', 'Marital Status')} : {familyInfoSettings?.maritalStatus?.label || ''} </p>
                                                        </UAlertMessage>}

                                                    </div>}

                                                {/**  Old Flow add buttom and delete family info*/}
                                                {(familyInfo?.length > 1 && secIndex === 3) &&
                                                    <div className="u_col-12 u_mb-20 u_flex-align">
                                                        <h6>Family Information {index + 1}</h6>
                                                        {(familyInfo?.length > 1 && !props?.disabled) &&
                                                            <span className="u_cp u_ml-15"
                                                                  onClick={() => handle?.deleteMoreFamily(index, secIndex)}>
                                                                <Icon.Delete fill={COLOR.u_blue} size={16}/>
                                                            </span>}
                                                    </div>}

                                                {/** Add delete children*/}
                                                {
                                                    childrenIds?.includes(family?.familyRole) &&
                                                    <div className="u_col-12 u_mb-20 u_flex-align">
                                                        <h6>Children {index + 1}</h6>
                                                        {!props?.disabled && <span className="u_cp u_ml-15" onClick={() => handle?.deleteMoreChildren(index, secIndex)}><Icon.Delete fill={COLOR.u_blue} size={16}/></span>}
                                                        {familyInfoSettings?.isChildrenInfoEnabled && familyInfoSettings?.isFamilyInfoEnabled &&
                                                            <UCheckBox
                                                                disableClass={props?.disabled}
                                                                className={'u_ml-15'}
                                                                id={`isEligibleForInsurance${index}`}
                                                                name={`isEligibleForInsurance${index}`}
                                                                label={`Eligible for ${getLabel(PROFILE_SECTION.basicInfo, 'companyId', 'Company')} insurance`}
                                                                checked={family?.isEligibleForInsurance}
                                                                onChange={(e) => handle.changeFamily(e?.target?.checked, 'isEligibleForInsurance', index, secIndex)}
                                                            />}
                                                    </div>
                                                }

                                                {/**  Select Family Member Role Other , like Sister , Brother, Custom Relationship */}
                                                {
                                                    (secIndex === 3) &&
                                                    <div className={`u_col-4 u_mb-25`}>
                                                        <UInput label={getLabel(PROFILE_SECTION.basicInfo, 'familyRole', 'Relationship')} select selectValue={family?.familyRole}
                                                                hasError={false}>
                                                            <Select
                                                                isDisabled={props?.disabled}
                                                                classNamePrefix="u_select"
                                                                className="u_input-select-inner"
                                                                placeholder=" "
                                                                options={_FS_LV?.filter(_ => otherIds?.includes(_?.value))}
                                                                value={getKeyName(_FS_LV, family?.familyRole)}
                                                                name={`familyRole_${index}${secIndex}`}
                                                                onChange={(e) => handle.changeFamily(e?.value, 'familyRole', index, secIndex)}
                                                                maxMenuHeight={90}
                                                                isClearable={true}
                                                            />
                                                        </UInput>
                                                    </div>
                                                }

                                                {/**  Select Family Member Role Other , like Sister , Brother, Custom Relationship */}
                                                {(secIndex === 3 ? family?.familyRole : true) &&
                                                    <React.Fragment>
                                                        <div className={`u_col-4 u_mb-25`}>
                                                            <UInput label={getLabel(PROFILE_SECTION.familyInfo, 'name', 'Name')} asterisk={family?.isRequired || (secIndex === 3 && family?.familyRole)}
                                                                    hasError={(family?.isRequired || (secIndex === 3 && family?.familyRole)) ? props?.validator.current.message(`name${index}${secIndex}`, family?.name, 'required|between:1,100,string') : false}>
                                                                <input
                                                                    disabled={props?.disabled}
                                                                    type="text"
                                                                    placeholder=" "
                                                                    name={`name ${index}`}
                                                                    value={family?.name}
                                                                    onChange={(e) => handle.changeFamily(e.target.value, 'name', index, secIndex)}
                                                                    autoComplete="off"
                                                                />
                                                            </UInput>
                                                        </div>
                                                        <div className={`u_col-4 u_mb-25`}>
                                                            <UInput label={getLabel(PROFILE_SECTION.basicInfo, 'gender', 'Gender')} select asterisk={family?.isRequired || (secIndex === 3 && family?.familyRole)}
                                                                    hasError={(family?.isRequired || (secIndex === 3 && family?.familyRole)) ? props?.validator.current.message(`gender${index}${secIndex}`, family?.gender, 'required'): false}
                                                                    selectValue={family?.gender}
                                                                    isLoading={dataLoading}>
                                                                <Select
                                                                    isDisabled={props?.disabled}
                                                                    className={`u_input-select-inner u_input-select-overlay`}
                                                                    classNamePrefix="u_select"
                                                                    options={CONSTANT?.GENDER_LIST}
                                                                    placeholder=" "
                                                                    name={`gender ${index}`}
                                                                    menuPlacement='auto'
                                                                    value={ getKeyName(CONSTANT?.GENDER_LIST, family?.gender)}
                                                                    onChange={(e) => handle.changeFamily(e?.value, 'gender', index, secIndex)}
                                                                />
                                                            </UInput>
                                                        </div>

                                                        {family?.isLate && <div className={`u_col-4 u_mb-25`}>
                                                            <UInput label={getLabel(PROFILE_SECTION.familyInfo, 'dateOfDeath', 'Date of Death')} datepicker asterisk={family?.isRequired || (secIndex === 3 && family?.familyRole)}
                                                                    hasError={(family?.isRequired || (secIndex === 3 && family?.familyRole)) ? props?.validator.current.message(`dateOfDeath${index}${secIndex}`, family?.dateOfDeath, 'required'): false}
                                                                    selectDate={family?.dateOfDeath ? new Date(family?.dateOfDeath) : ''}>
                                                                <UDatePicker
                                                                    disabled={props?.disabled}
                                                                    showDisabledMonthNavigation
                                                                    placeholderText=" "
                                                                    name={`dateOfDeath ${index}`}
                                                                    onChange={(e) => handle.changeFamily(e, 'dateOfDeath', index, secIndex)}
                                                                    selected={family?.dateOfDeath ? new Date(family?.dateOfDeath) : ''}
                                                                    maxDate={new Date()}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    popperPlacement="bottom-start"
                                                                />
                                                            </UInput>
                                                        </div>}

                                                        {/** For Spouse info OR  Children info Date of Divorce Visible  */}
                                                        {((familyInfoSettings?.isDivorce && secIndex === 1) || (family?.maritalStatus && secIndex === 2 && family.maritalStatus === 'divorced')) && <div className={`u_col-4 u_mb-25`}>
                                                            <UInput label={getLabel(PROFILE_SECTION.familyInfo, 'dateOfDivorce', 'Date of Divorce')} datepicker
                                                                    asterisk={family?.isRequired || (family?.familyRole)}
                                                                    hasError={family?.isRequired || (family?.familyRole) ? props?.validator.current.message(`dateOfDivorce${index}${secIndex}`, family?.dateOfDivorce, 'required'): false}
                                                                    selectDate={family?.dateOfDivorce ? new Date(family?.dateOfDivorce) : ''}>
                                                                <UDatePicker
                                                                    disabled={props?.disabled}
                                                                    showDisabledMonthNavigation
                                                                    placeholderText=" "
                                                                    name={`dateOfDivorce ${index}`}
                                                                    onChange={(e) => handle.changeFamily(e, 'dateOfDivorce', index, secIndex)}
                                                                    selected={family?.dateOfDivorce ? new Date(family?.dateOfDivorce) : ''}
                                                                    maxDate={new Date()}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    popperPlacement="bottom-start"
                                                                    // disabled={formDisabled()}
                                                                />
                                                            </UInput>
                                                        </div>}

                                                        {!family?.isLate && <div className={`u_col-4 u_mb-25`}>
                                                            <UInput label={getLabel(PROFILE_SECTION.basicInfo, 'dob', 'Date of Birth')} datepicker asterisk={family?.isRequired}
                                                                     hasError={(family?.isRequired) ? props?.validator.current.message(`dob_${family?.familyRole || "familyRole"}_${index}`, family?.dob, 'required'): false}
                                                                    selectDate={family?.dob ? new Date(family?.dob) : null}>
                                                                <UDatePicker
                                                                    disabled={props?.disabled}
                                                                    showDisabledMonthNavigation
                                                                    placeholderText=" "
                                                                    name={`dob ${index}`}
                                                                    onChange={(e) => handle.changeFamily(e, 'dob', index, secIndex)}
                                                                    selected={family?.dob ? new Date(family?.dob) : ''}
                                                                    maxDate={new Date()}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    popperPlacement="bottom-start"
                                                                />
                                                            </UInput>
                                                        </div>}

                                                        {(!childrenIds?.includes(family?.familyRole) && !family?.isLate) && <div className={`u_col-4 u_mb-25`}>
                                                            <UInput label={getLabel(PROFILE_SECTION.familyInfo, 'occupation', 'Occupation')} hasError={false}>
                                                                <input
                                                                    disabled={props?.disabled}
                                                                    type="text"
                                                                    placeholder=" "
                                                                    name={`occupation ${index}`}
                                                                    value={family?.occupation}
                                                                    onChange={(e) => handle.changeFamily(e.target.value, 'occupation', index, secIndex)}
                                                                    autoComplete="off"
                                                                />
                                                            </UInput>
                                                        </div>}
                                                        {(!childrenIds?.includes(family?.familyRole) && !family?.isLate) && <div className="u_col-4 u_mb-25">
                                                            <UInput label={`${getLabel(PROFILE_SECTION.familyInfo, 'mobileNumber', 'Mobile Number')}`} isFocused
                                                                    hasError={false}
                                                                    disabled={props?.disabled}
                                                                    isLoading={dataLoading}>
                                                                <UCountryMobile
                                                                    disabled={props?.disabled}
                                                                    code={family.mobileNumberCC}
                                                                    phone={family.mobileNumber}
                                                                    onChange={(e) => handle.mobileNumber(e, 'mobileNumber', index, secIndex)}
                                                                />
                                                            </UInput>
                                                        </div>}

                                                        {!family?.isLate && <div className="u_col-4 u_mb-25">
                                                            <UInput
                                                                label={`${getLabel(PROFILE_SECTION.familyInfo, 'aadharNumber', 'Aadhaar Card (UID)')}`}
                                                                hasError={props?.validator.current.message(`aadharNumber${index}`, family?.aadharNumber, 'regex:^\\d{4}\\s?\\d{4}\\s?\\d{4}$')}
                                                            >
                                                                <input
                                                                    disabled={props?.disabled}
                                                                    type="number"
                                                                    placeholder=" "
                                                                    name="aadharNumber"
                                                                    value={family?.aadharNumber ?? ''}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        if (value.length <= 12) {
                                                                            handle.changeFamily(value, 'aadharNumber', index, secIndex);
                                                                        }
                                                                    }}
                                                                    maxLength={12} // Prevents typing more than 12 characters
                                                                    autoComplete="off"
                                                                />
                                                            </UInput>
                                                        </div>}

                                                        {childrenIds?.includes(family?.familyRole) && family.gender === "female" &&
                                                        <div className={`u_col-4 u_mb-25`}>
                                                            <UInput label={getLabel(PROFILE_SECTION.basicInfo, 'maritalStatus', 'Marital Status')} select asterisk={family?.isRequired || (family?.familyRole)}
                                                                    hasError={(family?.isRequired || (family?.familyRole)) ? props?.validator.current.message(`maritalStatus${index}${secIndex}`, family?.maritalStatus, 'required'): false}
                                                                    selectValue={family?.maritalStatus}
                                                                    isLoading={dataLoading}>
                                                                <Select
                                                                    isDisable={props?.disabled}
                                                                    className={`u_input-select-inner u_input-select-overlay`}
                                                                    classNamePrefix="u_select"
                                                                    options={CONSTANT?.MARITAL_STATUS_LIST}
                                                                    placeholder=" "
                                                                    name={`maritalStatus ${index}`}
                                                                    menuPlacement='auto'
                                                                    value={ getKeyName(CONSTANT?.MARITAL_STATUS_LIST, family?.maritalStatus)}
                                                                    onChange={(e) => handle.changeFamily(e?.value, 'maritalStatus', index, secIndex)}
                                                                />
                                                            </UInput>
                                                        </div>}

                                                        {((spouseIds?.includes(family?.familyRole) && !family?.isLate) || (childrenIds?.includes(family?.familyRole) && family.gender === "female" && family?.maritalStatus === 'married')) && <div className={`u_col-4 u_mb-25`}>
                                                            <UInput label={getLabel(PROFILE_SECTION.familyInfo, 'weddingAnniversaryDate', 'Wedding Anniversary Date')} datepicker
                                                                    asterisk={family?.isRequired || (family?.familyRole)}
                                                                    hasError={(family?.isRequired || (family?.familyRole)) ? props?.validator.current.message(`weddingAnniversaryDate${index}${secIndex}`, family?.weddingAnniversaryDate, 'required'): false}
                                                                    selectDate={family?.weddingAnniversaryDate  ? new Date(family?.weddingAnniversaryDate ) : ''}>
                                                                <UDatePicker
                                                                    disabled={props?.disabled}
                                                                    showDisabledMonthNavigation
                                                                    placeholderText=" "
                                                                    name={`weddingAnniversaryDate${index}`}
                                                                    onChange={(e) => handle.changeFamily(e, 'weddingAnniversaryDate', index, secIndex)}
                                                                    selected={family?.weddingAnniversaryDate ? new Date(family?.weddingAnniversaryDate) : ''}
                                                                    maxDate={new Date()}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    popperPlacement="bottom-start"
                                                                />
                                                            </UInput>
                                                        </div>}

                                                        {/* Physically Handicapped for parants and spouse */}
                                                        {!family?.isLate && <div className="u_col-4 u_flex-align u_mb-25">
                                                            <UToggleSwitch
                                                                id={`parentsInfo_isHandicapped_${index}${secIndex}`}
                                                                checked={family?.isHandicapped}
                                                                disabled={props?.disabled}
                                                                onChange={(e) => handle.changeFamily(e?.target?.checked, 'isHandicapped', index, secIndex)}/>
                                                            <p className="u_font u_ml-10">{getLabel(PROFILE_SECTION.familyInfo, 'isHandicapped', 'Physically Handicapped')}</p>
                                                        </div>}

                                                        {!family?.isLate && family?.isHandicapped &&
                                                            <div className="u_col-4 u_mb-25">
                                                                <UInput label={`${getLabel(PROFILE_SECTION.familyInfo, 'handicappedPercentage', 'Handicap Percentage')}`}
                                                                        onWheelCapture={e => e.target.blur()} onKeyDown={e => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()}
                                                                        asterisk
                                                                        placeholder=" "
                                                                        hasError={family?.isHandicapped ? props?.validator?.current.message(`Handicapped Percentage${index}${secIndex}`, family?.handicappedPercentage, `required|numeric|min:1,num|max:100,num`) : false}
                                                                >
                                                                    <input type='number' autoComplete='off' name="handicappedPercentage" disabled={props?.disabled}
                                                                           onWheelCapture={e => e.target.blur()}
                                                                           onKeyDown={e => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()}
                                                                           placeholder="0"
                                                                           value={Number(family?.handicappedPercentage)}
                                                                           onChange={(e) => handle.changeFamily(Number(e.target.value), 'handicappedPercentage', index, secIndex)}
                                                                    />
                                                                </UInput>
                                                            </div>}

                                                        <div className="u_col-12 u_mb-25">
                                                            <div className="u_flex u_align-center u_mb-15">
                                                                <label className="u_label u_mr-5">Attachment</label>
                                                                <UPopup
                                                                    params={{ className: "u_tooltip u_tooltip-full" }}
                                                                    desc={<span>You can upload Maximum 3 files. Supported file formats: JPG, JPEG, PNG, PDF.</span>}
                                                                >
                                                                    <span className="u_rollover u_cp u_flex">
                                                                        <Icon.InfoTooltip fill={COLOR.u_icon_bg} size={18} />
                                                                    </span>
                                                                </UPopup>
                                                            </div>
                                                            <div className="u_flex-align">
                                                                {family?.attachments?.length > 0 &&
                                                                    family?.attachments?.map((attachment, fIndex) => {
                                                                        return <FileAttachment key={`fam_upload${secIndex}${index}${fIndex}`} doc={family} file={attachment} index={fIndex} action={{ delete: (doc, file, fIdx) => handle.deleteAttachment(doc, file, fIdx, index, secIndex) }} name={"familyInfo"} />
                                                                    })
                                                                }
                                                                {(family?.attachments?.length || 0) < 3 && !loading && !props?.disabled &&
                                                                    <AddFile add={(e) => handle.file(e, index, secIndex)}
                                                                        name={`familyAddFile${secIndex}_${index}`} />
                                                                }
                                                                {loading === `${secIndex}_${index}` && <div className={`u_file-attachment loading`}><FileProgressBar uploadPercentage={100} /></div>}
                                                            </div>
                                                        </div>

                                                    </React.Fragment>}
                                            </div>
                                        })

                                    }

                                    {(secIndex === 0 && familyInfoSettings?.isMarried === null) &&
                                        <UAlertMessage warning>
                                            <p className="u_flex-align">Note: To add your spouse or child, please select your marital status first.</p>
                                        </UAlertMessage>
                                    }
                                    {(secIndex === 3) && <span><AddNewButton disabled={props?.disabled} title="Member" action={() => handle?.addMoreFamily(secIndex)}/></span>}
                                    {(secIndex === 2 && section?.isChildrenCovered) && <span><AddNewButton disabled={props?.disabled} title="Children" action={() => handle?.addMoreChildren(secIndex)}/></span>}

                                </div>
                            </React.Fragment>
                        )
                    })
                }
            </React.Fragment>
        );
    } else if(props?.showNoDataFound) {
        return(
            <div className={'u_h-full'}>
                {!showFamilyInfo &&
                    <div className={'u_p-15'}>
                        <UAlertMessage danger>
                            <p className="u_flex-align"> Note : Family information is hidden because it's turned off in the "Information Gathering" step — to collect it, mark the fields as Mandatory or Optional.</p>
                        </UAlertMessage>
                    </div>
                }
                <UNoDataFound width={300} image="/images/no-data-found.svg" message="No data to display"/>) :
            </div>
        );
    } else {
        return("");
    }
})

export default FamilyInformation;